// source: src/grpc/account.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.account.AccountData', null, global);
goog.exportSymbol('proto.account.UserDealData', null, global);
goog.exportSymbol('proto.account.UserHistoryReply', null, global);
goog.exportSymbol('proto.account.UserHistoryRequest', null, global);
goog.exportSymbol('proto.account.UserOrderData', null, global);
goog.exportSymbol('proto.account.UserPositionData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.account.AccountData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.account.AccountData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.account.AccountData.displayName = 'proto.account.AccountData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.account.UserHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.account.UserHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.account.UserHistoryRequest.displayName = 'proto.account.UserHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.account.UserHistoryReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.account.UserHistoryReply.repeatedFields_, null);
};
goog.inherits(proto.account.UserHistoryReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.account.UserHistoryReply.displayName = 'proto.account.UserHistoryReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.account.UserPositionData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.account.UserPositionData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.account.UserPositionData.displayName = 'proto.account.UserPositionData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.account.UserDealData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.account.UserDealData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.account.UserDealData.displayName = 'proto.account.UserDealData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.account.UserOrderData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.account.UserOrderData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.account.UserOrderData.displayName = 'proto.account.UserOrderData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.account.AccountData.prototype.toObject = function(opt_includeInstance) {
  return proto.account.AccountData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.account.AccountData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.AccountData.toObject = function(includeInstance, msg) {
  var f, obj = {
    login: jspb.Message.getFieldWithDefault(msg, 1, 0),
    currencyDigits: jspb.Message.getFieldWithDefault(msg, 2, 0),
    balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    credit: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    equity: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    margin: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    marginFree: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    marginLevel: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    marginLeverage: jspb.Message.getFieldWithDefault(msg, 9, 0),
    profit: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.account.AccountData}
 */
proto.account.AccountData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.account.AccountData;
  return proto.account.AccountData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.account.AccountData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.account.AccountData}
 */
proto.account.AccountData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLogin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCurrencyDigits(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCredit(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquity(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMargin(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarginFree(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarginLevel(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMarginLeverage(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.account.AccountData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.account.AccountData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.account.AccountData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.AccountData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLogin();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCurrencyDigits();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getCredit();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMargin();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getMarginFree();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getMarginLevel();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getMarginLeverage();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
};


/**
 * optional uint64 login = 1;
 * @return {number}
 */
proto.account.AccountData.prototype.getLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 currency_digits = 2;
 * @return {number}
 */
proto.account.AccountData.prototype.getCurrencyDigits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setCurrencyDigits = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double balance = 3;
 * @return {number}
 */
proto.account.AccountData.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double credit = 4;
 * @return {number}
 */
proto.account.AccountData.prototype.getCredit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setCredit = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double equity = 5;
 * @return {number}
 */
proto.account.AccountData.prototype.getEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double margin = 6;
 * @return {number}
 */
proto.account.AccountData.prototype.getMargin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setMargin = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double margin_free = 7;
 * @return {number}
 */
proto.account.AccountData.prototype.getMarginFree = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setMarginFree = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double margin_level = 8;
 * @return {number}
 */
proto.account.AccountData.prototype.getMarginLevel = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setMarginLevel = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional uint32 margin_leverage = 9;
 * @return {number}
 */
proto.account.AccountData.prototype.getMarginLeverage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setMarginLeverage = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional double profit = 10;
 * @return {number}
 */
proto.account.AccountData.prototype.getProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.AccountData} returns this
 */
proto.account.AccountData.prototype.setProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.account.UserHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.account.UserHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.account.UserHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, 0),
    to: jspb.Message.getFieldWithDefault(msg, 2, 0),
    mode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.account.UserHistoryRequest}
 */
proto.account.UserHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.account.UserHistoryRequest;
  return proto.account.UserHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.account.UserHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.account.UserHistoryRequest}
 */
proto.account.UserHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTo(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.account.UserHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.account.UserHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.account.UserHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMode();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 from = 1;
 * @return {number}
 */
proto.account.UserHistoryRequest.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserHistoryRequest} returns this
 */
proto.account.UserHistoryRequest.prototype.setFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 to = 2;
 * @return {number}
 */
proto.account.UserHistoryRequest.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserHistoryRequest} returns this
 */
proto.account.UserHistoryRequest.prototype.setTo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 mode = 3;
 * @return {number}
 */
proto.account.UserHistoryRequest.prototype.getMode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserHistoryRequest} returns this
 */
proto.account.UserHistoryRequest.prototype.setMode = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.account.UserHistoryRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserHistoryRequest} returns this
 */
proto.account.UserHistoryRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.account.UserHistoryReply.repeatedFields_ = [2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.account.UserHistoryReply.prototype.toObject = function(opt_includeInstance) {
  return proto.account.UserHistoryReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.account.UserHistoryReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserHistoryReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    positionsList: jspb.Message.toObjectList(msg.getPositionsList(),
    proto.account.UserPositionData.toObject, includeInstance),
    dealsList: jspb.Message.toObjectList(msg.getDealsList(),
    proto.account.UserDealData.toObject, includeInstance),
    ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    proto.account.UserOrderData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.account.UserHistoryReply}
 */
proto.account.UserHistoryReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.account.UserHistoryReply;
  return proto.account.UserHistoryReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.account.UserHistoryReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.account.UserHistoryReply}
 */
proto.account.UserHistoryReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMode(value);
      break;
    case 2:
      var value = new proto.account.UserPositionData;
      reader.readMessage(value,proto.account.UserPositionData.deserializeBinaryFromReader);
      msg.addPositions(value);
      break;
    case 3:
      var value = new proto.account.UserDealData;
      reader.readMessage(value,proto.account.UserDealData.deserializeBinaryFromReader);
      msg.addDeals(value);
      break;
    case 4:
      var value = new proto.account.UserOrderData;
      reader.readMessage(value,proto.account.UserOrderData.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.account.UserHistoryReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.account.UserHistoryReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.account.UserHistoryReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserHistoryReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.account.UserPositionData.serializeBinaryToWriter
    );
  }
  f = message.getDealsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.account.UserDealData.serializeBinaryToWriter
    );
  }
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.account.UserOrderData.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 mode = 1;
 * @return {number}
 */
proto.account.UserHistoryReply.prototype.getMode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserHistoryReply} returns this
 */
proto.account.UserHistoryReply.prototype.setMode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated UserPositionData positions = 2;
 * @return {!Array<!proto.account.UserPositionData>}
 */
proto.account.UserHistoryReply.prototype.getPositionsList = function() {
  return /** @type{!Array<!proto.account.UserPositionData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.account.UserPositionData, 2));
};


/**
 * @param {!Array<!proto.account.UserPositionData>} value
 * @return {!proto.account.UserHistoryReply} returns this
*/
proto.account.UserHistoryReply.prototype.setPositionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.account.UserPositionData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.account.UserPositionData}
 */
proto.account.UserHistoryReply.prototype.addPositions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.account.UserPositionData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.account.UserHistoryReply} returns this
 */
proto.account.UserHistoryReply.prototype.clearPositionsList = function() {
  return this.setPositionsList([]);
};


/**
 * repeated UserDealData deals = 3;
 * @return {!Array<!proto.account.UserDealData>}
 */
proto.account.UserHistoryReply.prototype.getDealsList = function() {
  return /** @type{!Array<!proto.account.UserDealData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.account.UserDealData, 3));
};


/**
 * @param {!Array<!proto.account.UserDealData>} value
 * @return {!proto.account.UserHistoryReply} returns this
*/
proto.account.UserHistoryReply.prototype.setDealsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.account.UserDealData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.account.UserDealData}
 */
proto.account.UserHistoryReply.prototype.addDeals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.account.UserDealData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.account.UserHistoryReply} returns this
 */
proto.account.UserHistoryReply.prototype.clearDealsList = function() {
  return this.setDealsList([]);
};


/**
 * repeated UserOrderData orders = 4;
 * @return {!Array<!proto.account.UserOrderData>}
 */
proto.account.UserHistoryReply.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.account.UserOrderData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.account.UserOrderData, 4));
};


/**
 * @param {!Array<!proto.account.UserOrderData>} value
 * @return {!proto.account.UserHistoryReply} returns this
*/
proto.account.UserHistoryReply.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.account.UserOrderData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.account.UserOrderData}
 */
proto.account.UserHistoryReply.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.account.UserOrderData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.account.UserHistoryReply} returns this
 */
proto.account.UserHistoryReply.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.account.UserPositionData.prototype.toObject = function(opt_includeInstance) {
  return proto.account.UserPositionData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.account.UserPositionData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserPositionData.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: jspb.Message.getFieldWithDefault(msg, 1, 0),
    action: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
    comment: jspb.Message.getFieldWithDefault(msg, 4, ""),
    profit: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    closePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    openTime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    closeTime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    tp: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    sl: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    openPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    volume: jspb.Message.getFieldWithDefault(msg, 12, 0),
    digits: jspb.Message.getFieldWithDefault(msg, 13, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 14, ""),
    contractSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    login: jspb.Message.getFieldWithDefault(msg, 16, 0),
    swap: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
    commission: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.account.UserPositionData}
 */
proto.account.UserPositionData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.account.UserPositionData;
  return proto.account.UserPositionData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.account.UserPositionData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.account.UserPositionData}
 */
proto.account.UserPositionData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAction(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosePrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenTime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCloseTime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTp(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSl(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPrice(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVolume(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDigits(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContractSize(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLogin(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSwap(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommission(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.account.UserPositionData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.account.UserPositionData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.account.UserPositionData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserPositionData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getAction();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getClosePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getOpenTime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCloseTime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getTp();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getSl();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getOpenPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getDigits();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getContractSize();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getLogin();
  if (f !== 0) {
    writer.writeUint64(
      16,
      f
    );
  }
  f = message.getSwap();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getCommission();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
};


/**
 * optional uint64 ticket = 1;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getTicket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setTicket = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 action = 2;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getAction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setAction = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 timestamp = 3;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string comment = 4;
 * @return {string}
 */
proto.account.UserPositionData.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double profit = 5;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double close_price = 6;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getClosePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setClosePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 open_time = 7;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getOpenTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setOpenTime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 close_time = 8;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getCloseTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setCloseTime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double tp = 9;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getTp = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setTp = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double sl = 10;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getSl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setSl = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double open_price = 11;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getOpenPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setOpenPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional uint64 volume = 12;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint32 digits = 13;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getDigits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setDigits = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string symbol = 14;
 * @return {string}
 */
proto.account.UserPositionData.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional double contract_size = 15;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getContractSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setContractSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional uint64 login = 16;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional double swap = 17;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getSwap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setSwap = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double commission = 18;
 * @return {number}
 */
proto.account.UserPositionData.prototype.getCommission = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserPositionData} returns this
 */
proto.account.UserPositionData.prototype.setCommission = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.account.UserDealData.prototype.toObject = function(opt_includeInstance) {
  return proto.account.UserDealData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.account.UserDealData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserDealData.toObject = function(includeInstance, msg) {
  var f, obj = {
    deal: jspb.Message.getFieldWithDefault(msg, 1, 0),
    externalId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    login: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dealer: jspb.Message.getFieldWithDefault(msg, 4, 0),
    order: jspb.Message.getFieldWithDefault(msg, 5, 0),
    action: jspb.Message.getFieldWithDefault(msg, 6, 0),
    entry: jspb.Message.getFieldWithDefault(msg, 7, 0),
    digits: jspb.Message.getFieldWithDefault(msg, 8, 0),
    digitsCurrency: jspb.Message.getFieldWithDefault(msg, 9, 0),
    contractSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    time: jspb.Message.getFieldWithDefault(msg, 11, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 12, ""),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    volume: jspb.Message.getFieldWithDefault(msg, 14, 0),
    profit: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    storage: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    commission: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
    rateMargin: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
    expertId: jspb.Message.getFieldWithDefault(msg, 19, 0),
    positionId: jspb.Message.getFieldWithDefault(msg, 20, 0),
    comment: jspb.Message.getFieldWithDefault(msg, 21, ""),
    timeMsc: jspb.Message.getFieldWithDefault(msg, 22, 0),
    priceSl: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
    priceTp: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
    fee: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
    swap: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
    marketBid: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
    marketAsk: jspb.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
    reason: jspb.Message.getFieldWithDefault(msg, 30, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.account.UserDealData}
 */
proto.account.UserDealData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.account.UserDealData;
  return proto.account.UserDealData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.account.UserDealData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.account.UserDealData}
 */
proto.account.UserDealData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDeal(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLogin(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDealer(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOrder(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAction(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEntry(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDigits(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDigitsCurrency(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContractSize(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVolume(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfit(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStorage(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommission(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRateMargin(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpertId(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPositionId(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeMsc(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceSl(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceTp(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFee(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSwap(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarketBid(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarketAsk(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.account.UserDealData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.account.UserDealData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.account.UserDealData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserDealData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeal();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogin();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getDealer();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getAction();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getEntry();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getDigits();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getDigitsCurrency();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getContractSize();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeUint64(
      14,
      f
    );
  }
  f = message.getProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getStorage();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getCommission();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getRateMargin();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getExpertId();
  if (f !== 0) {
    writer.writeUint64(
      19,
      f
    );
  }
  f = message.getPositionId();
  if (f !== 0) {
    writer.writeUint64(
      20,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getTimeMsc();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getPriceSl();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getPriceTp();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getFee();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getSwap();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getMarketBid();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getMarketAsk();
  if (f !== 0.0) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getReason();
  if (f !== 0) {
    writer.writeUint32(
      30,
      f
    );
  }
};


/**
 * optional uint64 deal = 1;
 * @return {number}
 */
proto.account.UserDealData.prototype.getDeal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setDeal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string external_id = 2;
 * @return {string}
 */
proto.account.UserDealData.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 login = 3;
 * @return {number}
 */
proto.account.UserDealData.prototype.getLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 dealer = 4;
 * @return {number}
 */
proto.account.UserDealData.prototype.getDealer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setDealer = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 order = 5;
 * @return {number}
 */
proto.account.UserDealData.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 action = 6;
 * @return {number}
 */
proto.account.UserDealData.prototype.getAction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setAction = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 entry = 7;
 * @return {number}
 */
proto.account.UserDealData.prototype.getEntry = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setEntry = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 digits = 8;
 * @return {number}
 */
proto.account.UserDealData.prototype.getDigits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setDigits = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 digits_currency = 9;
 * @return {number}
 */
proto.account.UserDealData.prototype.getDigitsCurrency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setDigitsCurrency = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional double contract_size = 10;
 * @return {number}
 */
proto.account.UserDealData.prototype.getContractSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setContractSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional int64 time = 11;
 * @return {number}
 */
proto.account.UserDealData.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string symbol = 12;
 * @return {string}
 */
proto.account.UserDealData.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional double price = 13;
 * @return {number}
 */
proto.account.UserDealData.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional uint64 volume = 14;
 * @return {number}
 */
proto.account.UserDealData.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional double profit = 15;
 * @return {number}
 */
proto.account.UserDealData.prototype.getProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double storage = 16;
 * @return {number}
 */
proto.account.UserDealData.prototype.getStorage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setStorage = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double commission = 17;
 * @return {number}
 */
proto.account.UserDealData.prototype.getCommission = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setCommission = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double rate_margin = 18;
 * @return {number}
 */
proto.account.UserDealData.prototype.getRateMargin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setRateMargin = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional uint64 expert_id = 19;
 * @return {number}
 */
proto.account.UserDealData.prototype.getExpertId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setExpertId = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional uint64 position_id = 20;
 * @return {number}
 */
proto.account.UserDealData.prototype.getPositionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setPositionId = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string comment = 21;
 * @return {string}
 */
proto.account.UserDealData.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional int64 time_msc = 22;
 * @return {number}
 */
proto.account.UserDealData.prototype.getTimeMsc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setTimeMsc = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional double price_sl = 23;
 * @return {number}
 */
proto.account.UserDealData.prototype.getPriceSl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setPriceSl = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional double price_tp = 24;
 * @return {number}
 */
proto.account.UserDealData.prototype.getPriceTp = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setPriceTp = function(value) {
  return jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional double fee = 25;
 * @return {number}
 */
proto.account.UserDealData.prototype.getFee = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setFee = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double value = 26;
 * @return {number}
 */
proto.account.UserDealData.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double swap = 27;
 * @return {number}
 */
proto.account.UserDealData.prototype.getSwap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setSwap = function(value) {
  return jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional double market_bid = 28;
 * @return {number}
 */
proto.account.UserDealData.prototype.getMarketBid = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setMarketBid = function(value) {
  return jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional double market_ask = 29;
 * @return {number}
 */
proto.account.UserDealData.prototype.getMarketAsk = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setMarketAsk = function(value) {
  return jspb.Message.setProto3FloatField(this, 29, value);
};


/**
 * optional uint32 reason = 30;
 * @return {number}
 */
proto.account.UserDealData.prototype.getReason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserDealData} returns this
 */
proto.account.UserDealData.prototype.setReason = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.account.UserOrderData.prototype.toObject = function(opt_includeInstance) {
  return proto.account.UserOrderData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.account.UserOrderData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserOrderData.toObject = function(includeInstance, msg) {
  var f, obj = {
    order: jspb.Message.getFieldWithDefault(msg, 1, 0),
    externalId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    login: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dealer: jspb.Message.getFieldWithDefault(msg, 4, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    digits: jspb.Message.getFieldWithDefault(msg, 6, 0),
    digitsCurrency: jspb.Message.getFieldWithDefault(msg, 7, 0),
    contractSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    state: jspb.Message.getFieldWithDefault(msg, 9, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 10, 0),
    timeSetup: jspb.Message.getFieldWithDefault(msg, 11, 0),
    timeExpiration: jspb.Message.getFieldWithDefault(msg, 12, 0),
    timeDone: jspb.Message.getFieldWithDefault(msg, 13, 0),
    type: jspb.Message.getFieldWithDefault(msg, 14, 0),
    typeFill: jspb.Message.getFieldWithDefault(msg, 15, 0),
    typeTime: jspb.Message.getFieldWithDefault(msg, 16, 0),
    priceOrder: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
    priceTrigger: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
    priceCurrent: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
    priceSl: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    priceTp: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
    volumeInitial: jspb.Message.getFieldWithDefault(msg, 22, 0),
    volumeCurrent: jspb.Message.getFieldWithDefault(msg, 23, 0),
    expertId: jspb.Message.getFieldWithDefault(msg, 24, 0),
    positionId: jspb.Message.getFieldWithDefault(msg, 25, 0),
    comment: jspb.Message.getFieldWithDefault(msg, 26, ""),
    activationMode: jspb.Message.getFieldWithDefault(msg, 27, 0),
    activationTime: jspb.Message.getFieldWithDefault(msg, 28, 0),
    activationPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
    activationFlags: jspb.Message.getFieldWithDefault(msg, 30, 0),
    timeSetupMsc: jspb.Message.getFieldWithDefault(msg, 31, 0),
    timeDoneMsc: jspb.Message.getFieldWithDefault(msg, 32, 0),
    rateMargin: jspb.Message.getFloatingPointFieldWithDefault(msg, 33, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.account.UserOrderData}
 */
proto.account.UserOrderData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.account.UserOrderData;
  return proto.account.UserOrderData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.account.UserOrderData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.account.UserOrderData}
 */
proto.account.UserOrderData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLogin(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDealer(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDigits(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDigitsCurrency(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContractSize(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setState(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReason(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeSetup(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeExpiration(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeDone(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTypeFill(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTypeTime(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceOrder(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceTrigger(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceCurrent(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceSl(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceTp(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVolumeInitial(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVolumeCurrent(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpertId(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPositionId(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActivationMode(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActivationTime(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setActivationPrice(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActivationFlags(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeSetupMsc(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeDoneMsc(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRateMargin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.account.UserOrderData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.account.UserOrderData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.account.UserOrderData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.account.UserOrderData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogin();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getDealer();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDigits();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getDigitsCurrency();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getContractSize();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getState();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getReason();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getTimeSetup();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getTimeExpiration();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getTimeDone();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getTypeFill();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getTypeTime();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getPriceOrder();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getPriceTrigger();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getPriceCurrent();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getPriceSl();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getPriceTp();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getVolumeInitial();
  if (f !== 0) {
    writer.writeUint64(
      22,
      f
    );
  }
  f = message.getVolumeCurrent();
  if (f !== 0) {
    writer.writeUint64(
      23,
      f
    );
  }
  f = message.getExpertId();
  if (f !== 0) {
    writer.writeUint64(
      24,
      f
    );
  }
  f = message.getPositionId();
  if (f !== 0) {
    writer.writeUint64(
      25,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getActivationMode();
  if (f !== 0) {
    writer.writeUint32(
      27,
      f
    );
  }
  f = message.getActivationTime();
  if (f !== 0) {
    writer.writeInt64(
      28,
      f
    );
  }
  f = message.getActivationPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getActivationFlags();
  if (f !== 0) {
    writer.writeUint32(
      30,
      f
    );
  }
  f = message.getTimeSetupMsc();
  if (f !== 0) {
    writer.writeInt64(
      31,
      f
    );
  }
  f = message.getTimeDoneMsc();
  if (f !== 0) {
    writer.writeInt64(
      32,
      f
    );
  }
  f = message.getRateMargin();
  if (f !== 0.0) {
    writer.writeDouble(
      33,
      f
    );
  }
};


/**
 * optional uint64 order = 1;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string external_id = 2;
 * @return {string}
 */
proto.account.UserOrderData.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 login = 3;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 dealer = 4;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getDealer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setDealer = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.account.UserOrderData.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 digits = 6;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getDigits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setDigits = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 digits_currency = 7;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getDigitsCurrency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setDigitsCurrency = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double contract_size = 8;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getContractSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setContractSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional uint32 state = 9;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getState = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setState = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 reason = 10;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getReason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setReason = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 time_setup = 11;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getTimeSetup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setTimeSetup = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 time_expiration = 12;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getTimeExpiration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setTimeExpiration = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 time_done = 13;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getTimeDone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setTimeDone = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional uint32 type = 14;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint32 type_fill = 15;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getTypeFill = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setTypeFill = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint32 type_time = 16;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getTypeTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setTypeTime = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional double price_order = 17;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getPriceOrder = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setPriceOrder = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double price_trigger = 18;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getPriceTrigger = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setPriceTrigger = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional double price_current = 19;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getPriceCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setPriceCurrent = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional double price_sl = 20;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getPriceSl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setPriceSl = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional double price_tp = 21;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getPriceTp = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setPriceTp = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional uint64 volume_initial = 22;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getVolumeInitial = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setVolumeInitial = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional uint64 volume_current = 23;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getVolumeCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setVolumeCurrent = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional uint64 expert_id = 24;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getExpertId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setExpertId = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional uint64 position_id = 25;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getPositionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setPositionId = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional string comment = 26;
 * @return {string}
 */
proto.account.UserOrderData.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional uint32 activation_mode = 27;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getActivationMode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setActivationMode = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional int64 activation_time = 28;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getActivationTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setActivationTime = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * optional double activation_price = 29;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getActivationPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setActivationPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 29, value);
};


/**
 * optional uint32 activation_flags = 30;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getActivationFlags = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setActivationFlags = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional int64 time_setup_msc = 31;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getTimeSetupMsc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setTimeSetupMsc = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional int64 time_done_msc = 32;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getTimeDoneMsc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setTimeDoneMsc = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional double rate_margin = 33;
 * @return {number}
 */
proto.account.UserOrderData.prototype.getRateMargin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.account.UserOrderData} returns this
 */
proto.account.UserOrderData.prototype.setRateMargin = function(value) {
  return jspb.Message.setProto3FloatField(this, 33, value);
};


goog.object.extend(exports, proto.account);
